import React from 'react';
import ApiKeyManagement from '../components/ApiKeyManagement';

const ApiKeyManagementPage = () => {
  return (
    <div className="p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">API Key Management</h1>
          <p className="text-gray-600 mt-2">
            Generate and manage API keys for accessing ARMS services securely
          </p>
        </div>
        
        <ApiKeyManagement />
      </div>
    </div>
  );
};

export default ApiKeyManagementPage; 